<template>
  <div class="filters-container" :class="loading ? 'disabled' : ''">
    <div
      class="d-flex flex-row justify-content-between align-items-center bg-light-gray min-width-fit-content"
    >
      <div class="d-flex flex-wrap align-items-center">
        <b-form-input
          class="auth-input search-input border-color-light-gray"
          v-model="searchPhrase"
          placeholder="Search..."
          :readonly="loading"
        />
        <span class="ml-4 mr-3" style="font-size: 14px;">Active filters:</span>
        <div
          v-if="datetimeFrom || datetimeTo"
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Datetime:
              <span class="color-filter">{{
                datetimeFrom || datetimeTo
                  ? `(${
                      datetimeFrom
                        ? "From: " + formatDateOnly(datetimeFrom)
                        : ""
                    }${datetimeFrom && datetimeTo ? " - " : ""}${
                      datetimeTo ? "To: " + formatDateOnly(datetimeTo) : ""
                    })`
                  : ""
              }}</span>
            </span>
          </div>
        </div>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(user, userIndex) in users"
          :key="user.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >User: <span class="color-filter">{{ user.label }}</span></span
            >
            <i
              class="fa fa-times text-danger hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('users', userIndex)"
            ></i>
          </div>
        </div>
        <div
          class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          v-for="(loc, locIndex) in locations"
          :key="loc.value"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span class="mr-3"
              >Location: <span class="color-filter">{{ loc.label }}</span></span
            >
            <i
              class="fa fa-times text-danger hover-pointer hover-text-almost-black"
              @click="removeIndexFromFilter('locations', locIndex)"
            ></i>
          </div>
        </div>

        <span
          v-if="hasFilters"
          class="clear-all-filters text-danger ml-2"
          style="font-size: 14px;"
          @click="clearAllFilters"
          >Clear all filters</span
        >
      </div>
      <div class="d-flex align-self-stretch align-items-center">
        <div class="align-self-stretch" style="padding: 9px 0px;">
          <div class="vertical-separator border-med-light-gray"></div>
        </div>
        <b-dropdown
          id="dropdown-form"
          text="Filters"
          ref="filterDropdown"
          class="container-main bg-light-gray"
          toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
          menu-class="container-filter-main-menu"
          toggle-tag="div"
          boundary="window"
          right
        >
          <template #button-content>
            <div class="d-flex align-items-center mr-2">
              <i
                class="fas fa-filter text-primary mr-2"
                style="font-size: 15px;"
                aria-hidden="true"
              ></i>
              <span style="font-size: 14px;">Filters</span>
            </div>
          </template>
          <b-dropdown-form class="px-2">
            <b-form-group label="Filter by:">
              <b-form-select
                v-model="selectedFilter"
                :options="filterOptions"
              />
            </b-form-group>
          </b-dropdown-form>

          <date-range-filter
            v-if="selectedFilter === 'datetime'"
            v-model="filterDatetimeRange"
            :filterWidth="'250px'"
            :clearDate = true
            :restrictRange = true 
            label="Date Time"
          />
          <multiple-select-filter
            v-if="selectedFilter === 'user'"
            :label="'Users'"
            :options="allUsers"
            v-model="users"
            :width="'250px'"
            :showSearch="true"
          />
          <multiple-select-filter
            v-if="selectedFilter === 'location'"
            :label="'Locations'"
            :options="allLocations"
            v-model="locations"
            :width="'250px'"
            :showSearch="true"
          />
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import audit from "../../server/audit";
import moment from 'moment';
import { formatEndDateSql, formatStartDateSql } from '../../helpers/date';

export default {
  name: "AuditModalFilters",
  props: ["value", "hasFilters", "loading"],
  data() {
    return {
      selectedFilter: "user",
      orderOptions: [
        {
          value: "datetime",
          text: "Datetime"
        },
        {
          value: "user",
          text: "User"
        },
        {
          value: "location",
          text: "Location"
        }
      ],
      filterOptions: [
        {
          value: "datetime",
          text: "Datetime"
        },
        {
          value: "user",
          text: "User"
        },
        {
          value: "location",
          text: "Location"
        }
      ],
      allUsers: [],
      allLocations: [],
     filter: {
        datetimeFrom: null,
        datetimeTo: null
      },
    };
  },
  async mounted() {
    if(!this.value.datetimeFrom && !this.value.datetimeTo){
      const currentMomentUtc =  moment.utc();
      const currentMomentAdjusted = moment().subtract(31, 'days');
      this.value.datetimeFrom = currentMomentAdjusted.format('YYYY-MM-DD');
      this.value.datetimeTo = currentMomentUtc.format('YYYY-MM-DD');
    }
    this.filter.datetimeFrom =  formatStartDateSql(this.value.datetimeFrom);
    this.filter.datetimeTo =  formatEndDateSql(this.value.datetimeTo);
    const allUsers = await audit.findUsers(this.filter);
    this.allUsers = allUsers.map(x => ({ value: x, label: x }));
    const allLocations = await audit.findLocations(this.filter);
    this.allLocations = allLocations.map(x => ({ value: x, label: x }));    
  },
  methods: {
    removeIndexFromFilter(filterName, index) {
      const filter = [...this.value[filterName]];
      filter.splice(index, 1);
      this.$emit("input", { ...this.value, [filterName]: filter });
    },
    clearAllFilters() {
      const currentMomentUtc =  moment.utc();
      const currentMomentAdjusted = moment().subtract(31, 'days');
      this.$emit("input", {
        ...this.value,
        datetimeFrom: currentMomentAdjusted.format('YYYY-MM-DD'),
        datetimeTo: currentMomentUtc.format('YYYY-MM-DD'),
        users: [],
        locations: []
      });
    }
  },
  computed: {
    searchPhrase: {
      get() {
        return this.value.searchPhrase;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, searchPhrase: newValue });
      }
    },
    orderBy: {
      get() {
        return this.value.orderBy;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, orderBy: newValue });
      }
    },
    orderByText() {
      var option = this.orderOptions.find(opt => opt.value === this.orderBy);
      if (option) {
        return option.text;
      }
      return "";
    },
    orderByDescending: {
      get() {
        return this.value.orderByDescending;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, orderByDescending: newValue });
      }
    },
    sortingOrderClass() {
      return this.value.orderByDescending
        ? "fas fa-sort-amount-down"
        : "fas fa-sort-amount-up";
    },
    users: {
      get() {
        return this.value.users;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, users: newValue });
      }
    },
    locations: {
      get() {
        return this.value.locations;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, locations: newValue });
      }
    },
    filterDatetimeRange: {
      get() {
        return {
          dateFrom: this.value.datetimeFrom,
          dateTo: this.value.datetimeTo
        };
      },
      set(newValue) {
        const currentMomentUtc =  moment.utc();
        const currentMomentAdjusted = moment().subtract(31, 'days');
        if(!newValue.dateFrom && !newValue.dateTo){
          this.$emit("input", {
          ...this.value,
          datetimeFrom: currentMomentAdjusted.format('YYYY-MM-DD'),
          datetimeTo: currentMomentUtc.format('YYYY-MM-DD')
        });
        }else if(newValue.dateFrom != this.value.datetimeFrom &&
         (moment(this.value.datetimeTo).diff(moment(newValue.dateFrom), "days") > 31 || moment(this.value.datetimeTo).diff(moment(newValue.dateFrom), "days") < 0)){
          this.$emit("input", {
            ...this.value,
            datetimeFrom: newValue.dateFrom,
            datetimeTo: moment(newValue.dateFrom).add(31, "days").format('YYYY-MM-DD')
          });
        }else if(newValue.dateTo != this.value.datetimeTo && 
        (moment(newValue.dateTo).diff(moment(this.value.datetimeFrom), "days") > 31 || moment(newValue.dateTo).diff(moment(this.value.datetimeFrom), "days") < 0)){
          this.$emit("input", {
            ...this.value,
            datetimeFrom: moment(newValue.dateTo).subtract(31, "days").format('YYYY-MM-DD'),
            datetimeTo: newValue.dateTo
          });
        }else{
          this.$emit("input", {
            ...this.value,
            datetimeFrom: newValue.dateFrom,
            datetimeTo: newValue.dateTo
          });
        }
      }
    },
    datetimeFrom: {
      get() {
        return this.value.datetimeFrom;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, datetimeFrom: newValue });
      }
    },
    datetimeTo: {
      get() {
        return this.value.datetimeTo;
      },
      set(newValue) {
        this.$emit("input", { ...this.value, datetimeTo: newValue });
      }
    }
  },
  watch: {
    selectedFilter: function() {
      this.$refs.filterDropdown.updatePopper();
    }
  }
};
</script>

<style scoped>
.filters-container {
  overflow-x: auto;
}
.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}
.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}
.search-input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  width: 320px;
}
.color-filter {
  color: #909db8;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}
div.disabled {
  pointer-events: none;
  opacity: 0.5;
  background: #ccc;
}
.sorting-order-btn {
  background-color: white;
  color: #707070;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  padding: 1px 4px;
}
</style>
